import { useContext, useEffect } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";

type Transition = {
  action: unknown;
  location: {
    pathname: string;
    search: string;
    hash: string;
  };
  retry: () => void;
};

type NavigatorWithBlock = {
  block?: (cb: (tx: Transition) => void) => () => void;
};

export function useBrowserRouterBlocker(blocker: (tx: Transition) => void, when = true) {
  const { navigator } = useContext(NavigationContext) as unknown as { navigator: NavigatorWithBlock };

  useEffect(() => {
    if (!when) return;
    if (typeof navigator?.block !== "function") return;

    const unblock = navigator.block((tx) => {
      const autoUnblockingTx: Transition = {
        ...tx,
        retry() {
          unblock();
          tx.retry();
        },
      };

      blocker(autoUnblockingTx);
    });

    return unblock;
  }, [navigator, blocker, when]);
}
